import React from "react";
import AppBar from "../Landing/AppBar";
import JoinUs from "../Landing/JoinUs";
import Pricing from "./Pricing";

function PresentationPricing() {
  return (
    <React.Fragment>
      <AppBar />
      <Pricing />
      <JoinUs />
    </React.Fragment>
  );
}

export default PresentationPricing;
